import Button from '../../buttons/Button';

export default function Pagination({ page, pages, onChange }: { page: number; pages: number; onChange: (p: number) => void }) {
  if (pages <= 1) return null;
  return (
    <div className="row" style={{ justifyContent: 'flex-end' }}>
      <Button size="sm" variant="ghost" disabled={page <= 1} onClick={() => onChange(page - 1)}>‹ Anterior</Button>
      <span className="small muted">Página {page} de {pages}</span>
      <Button size="sm" variant="ghost" disabled={page >= pages} onClick={() => onChange(page + 1)}>Próxima ›</Button>
    </div>
  );
}
